import SubmitApplicationBtn from "./components/submit-application-btn/SubmitApplicationBtn";
import LMSService from "./services/LMSService";
const submitToLms = LMSService.submitToLms;

export { submitToLms, SubmitApplicationBtn };
